<div class="metrics-container">
  <div class="row first">
    <div class="metrics-title" [innerHTML]="'metrics_Data6' |i18n"></div>
    <div class="map" #pwaMapContainer>
      <img class="map-img" src="/assets/images/metrics/map.svg" alt="Map" [draggable]="false">
      <img class="mark-icon" src="/assets/images/metrics/mark.svg" alt="Mark"
        [ngClass]="{'active': selectedMetrics === allMetricsEnum.ECUADOR}"
        (click)="checkMetrics(allMetricsEnum.ECUADOR)">
      <img class="mark-icon" src="/assets/images/metrics/mark.svg" alt="Mark"
        [ngClass]="{'active': selectedMetrics === allMetricsEnum.ARGENTINA}"
        (click)="checkMetrics(allMetricsEnum.ARGENTINA)">
      <img class="mark-icon" src="/assets/images/metrics/mark.svg" alt="Mark"
        [ngClass]="{'active': selectedMetrics === allMetricsEnum.SPAIN}" (click)="checkMetrics(allMetricsEnum.SPAIN)">
      <img class="mark-icon" src="/assets/images/metrics/mark.svg" alt="Mark"
        [ngClass]="{'active': selectedMetrics === allMetricsEnum.PORTUGAL}"
        (click)="checkMetrics(allMetricsEnum.PORTUGAL)">
    </div>
  </div>
  <div class="move" [innerHTML]="'metrics_Data7' | i18n"></div>
  <div class="row second">
    <div class="box">
      <div class="box-title" [innerHTML]="'metrics_Data2' |i18n"></div>
      <div class="box-number" [innerHTML]="runKm | number:'1.0-3'"></div>
    </div>
    <div class="box">
      <div class="box-title" [innerHTML]="'metrics_Data3' |i18n"></div>
      <div class="box-number" [innerHTML]="detectedKm | number:'1.0-3'"></div>
    </div>
    <div class="box">
      <div class="box-title" [innerHTML]="'metrics_Data4' |i18n"></div>
      <div class="box-number" [innerHTML]="videos | number:'1.0-3'"></div>
    </div>
  </div>
</div>
